'use strict';

module.exports = require('./components/DisqusThread');